export enum Sort {
  Asc = 'asc',
  Desc = 'desc',
}
